/**
 * Figma 6419:83627 — 이용약관
 * 실 서비스 약관 문구는 법무 확정본으로 교체 필요.
 */

export type TermsTab = 'LEGAL' | 'POLICY';

export type TermsArticle = {
  id: string;
  heading: string;
  body: string;
};

export const LEGAL_ARTICLES: TermsArticle[] = [
  {
    id: 'article-1',
    heading: '제 1조 (목적)',
    body: `주식회사 팀바인드(이하 ‘회사’)가 제공하는 서비스를 이용해 주셔서 감사합니다. 회사는 여러분이 다양한 인터넷과 모바일 서비스를 좀 더 편리하게 이용할 수 있도록 회사 또는 관계사의 개별 서비스에 모두 접속 가능한 통합 로그인 계정 체계를 만들고 그에 적용되는 '밴더 약관(이하 '본 약관')을 마련하였습니다. 본 약관은 여러분이 밴더 계정 서비스를 이용하는 데 필요한 권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정하고 있으므로 조금만 시간을 내서 주의 깊게 읽어주시기 바랍니다.`,
  },
  {
    id: 'article-2',
    heading: '제 2조 (약관의 효력 및 변경)',
    body: `①본 약관의 내용은 밴더 웹사이트 또는 개별 서비스의 화면에 게시하거나 기타의 방법으로 공지하고, 본 약관에 동의한 여러분 모두에게 그 효력이 발생합니다.
②회사는 필요한 경우 관련법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있습니다. 본 약관이 변경되는 경우 회사는 변경사항을 시행일자 15일 전부터 여러분에게 서비스 공지사항에서 공지 또는 통지하는 것을 원칙으로 하며, 피치 못하게 여러분에게 불리한 내용으로 변경할 경우에는 그 시행일자 30일 전부터 밴더 계정에 등록된 이메일 주소로 이메일(이메일주소가 없는 경우 서비스 내 전자쪽지 발송, 서비스 내 알림 메시지를 띄우는 등의 별도의 전자적 수단) 발송 또는 여러분이 등록한 휴대폰번호로 문자메시지 발송하는 방법 등으로 개별적으로 알려 드리겠습니다.
③회사가 전항에 따라 공지 또는 통지를 하면서 공지 또는 통지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 승인한 것으로 본다는 뜻을 명확하게 고지하였음에도 여러분의 의사표시가 없는 경우에는 변경된 약관을 승인한 것으로 봅니다. 여러분이 개정약관에 동의하지 않을 경우 여러분은 이용계약을 해지할 수 있습니다.`,
  },
];

export const POLICY_ARTICLES: TermsArticle[] = [
  {
    id: 'policy-1',
    heading: '제 1조 (이용정책의 목적)',
    body: `본 이용정책은 회사가 제공하는 서비스의 이용과 관련하여 회원이 준수하여야 할 사항을 규정합니다. 서비스의 원활한 제공과 이용자 보호를 위해 회사는 필요한 범위 내에서 정책을 개정할 수 있습니다.`,
  },
  {
    id: 'policy-2',
    heading: '제 2조 (서비스 이용의 제한)',
    body: `타인에게 위해가 되는 행위, 서비스의 정상적인 운영을 방해하는 행위가 확인될 경우 서비스 이용이 제한될 수 있습니다. 자세한 사항은 고객센터 > 공지사항에서 확인해 주세요.`,
  },
];
